export default "__VITE_ASSET__DxKJAM1f__"